// extracted by mini-css-extract-plugin
export default {"component":"page_component__6eQww","title":"page_title__rle7v","header":"page_header__xkSGc","back":"page_back__xtAfI"};